module.exports = __webpack_public_path__ + "static/spreadsheet-page-background-155a3c76bfe3371f110e8296727ef737.png";